import(/* webpackMode: "eager" */ "/vercel/path0/src/app/khoa-hoc/[slug_url]/page.tsx");
